import $ from 'jquery';

class cdpInsightWithoutCommunicationAggreement{
  constructor() {
    if ($('#cdp-insight-without-communication-aggreement').length > 0){
      this.loading()
      this.init()
    }
  }

  init(){
    var cdpStat = this;
    $(document).ready(function() {
      setTimeout(function() {
        var result = { query: JSON.stringify(SegmentQueryBuilder.getMongoQuery()) };
        $.ajax({
          url: $('#cdp-insight-without-communication-aggreement').data('url'),
          method: 'GET',
          data: result,
          success: function (response) {
            cdpStat.renderStats(response)
          }
        });
      }, 1000);
    })
  }

  renderStats(response){
    $('#cdp-insight-without-communication-aggreement .card-body .card-body h4').text(this.transform(response.profiles_count));
    $('#cdp-insight-without-communication-aggreement .card-body .card-text').html(`<b>${this.transform(response.profiles_count)}</b>, (<b>${this.transform(response.profiles_percentage)}%</b>) сегмента, участников не имеют согласия на коммуникацию.`);
    $('#cdp-insight-without-communication-aggreement .peity-donut').text(`${response.profiles_percentage}/100`);
    $('#cdp-insight-without-communication-aggreement .peity-donut').peity('donut');
    this.loaded();
    this.toggleActionBtn(response.profiles_count);
  }

  toggleActionBtn(profiles_count){
    if (profiles_count > 0){
      $('#cdp-insight-without-communication-aggreement .segment-action-btn').removeClass('d-none');
    } else {
      $('#cdp-insight-without-communication-aggreement .segment-action-btn').addClass('d-none');
    }
  }

  loading(){
    $('#cdp-insight-without-communication-aggreement').addClass('loading');
  }

  loaded(){
    $('#cdp-insight-without-communication-aggreement').removeClass('loading');
  }

  transform(number) {
    return parseFloat(number).toLocaleString("ru")
  }
}

export default cdpInsightWithoutCommunicationAggreement;